// ws://10.175.147.78:8080/file/api/websocket/{deviceId}?spaceId=&userId=
import { nanoid } from 'nanoid'
import cookies from 'js-cookie'
import { cookieOptions } from '@/constants/auth'
import utils from '@/core/h5/utils/index'

export default class FileSocket {
    constructor(options) {
        const { params = {}, onMessage, onSuccess, fid = '', reconnectCallback } = options
        let deviceId = (cookies.get('deviceId') || params?.deviceId || '').replace(/\//g, '')
        const randomId = nanoid()
        if (!deviceId) {
            deviceId = nanoid();
            cookieOptions.map(item => {
                cookies.set('deviceId', deviceId, item)
            })
        }

        const { spaceId = '', userId = '' } = params
        this.ws = null
        const socketProtocal = window?.location?.protocol?.includes('https')
            ? 'wss:'
            : 'ws:'
        //旧版
        // const socketUrl = `${socketProtocal}${process.env.VUE_APP_BASE_URL}/file/api/realtime/${deviceId}/${fid}/${randomId}?spaceId=${spaceId}&userId=${userId}`
        //新版
        const socketUrl = `${socketProtocal}${process.env.VUE_APP_BASE_URL}/file/api/realtime/${fid}/${randomId}?spaceId=${spaceId}&userId=${userId}&deviceId=${deviceId}`
        this.uri = socketUrl
        this.lockReconnect = false
        this.onMessage = onMessage
        this.onSuccess = onSuccess
        this.reconnectCount = 0
        this.reconnectCallback = reconnectCallback;
        this.changeTab = false;
        this.deviceId = deviceId;
    }

    init() {
        // ws
        // CLOSED: 3
        // CLOSING: 2
        // CONNECTING: 0
        // OPEN: 1
        this.reconnectCount += 1
        try {
            if ('WebSocket' in window) {
                console.log('init WebSocket')
                this.ws = new window.WebSocket(this.uri)
            } else if ('MozWebSocket' in window) {
                console.log('init MozWebSocket')
                this.ws = new window.MozWebSocket(this.uri)
            } else {
                console.log('您的浏览器不支持websocket')
            }
            this.initEventHandle()
        } catch (e) {
            this.reconnect(this.uri)
        }
    }

    initEventHandle() {
        this.ws.onmessage = data => {
            if (!data) return
            try {
                const message = JSON.parse(data.data)
                this.onMessage(message)
            } catch (err) { }
        }

        this.ws.onopen = () => {
            console.log('消息通知 打开成功')
            // this.onSuccess()
        }

        this.ws.onclose = e => {
            console.log('消息通知 关闭成功', e)
            if (e.code === 1006) {
                console.log('消息通知 意外退出', e)
                this.reconnect(this.uri)
            }
        }
        this.ws.onerror = e => {
            console.log('消息通知 发生错误', e)
            this.reconnect(this.uri)
        }
    }

    clearWs() {
        this.ws && this.ws.close();
        if (this.ws && this.ws.onclose) {
            this.ws.onclose = null;
        }
        if (this.ws && this.ws.onerror) {
            this.ws.onerror = null;
        }
        if (this.ws && this.ws.onopen) {
            this.ws.onopen = null;
        }
        if (this.ws) {
            this.ws = null;
        }
    }

    wsClose() {
        this.lockReconnect = true
        this.clearWs()
    }

    reconnect(url) {
        if (this.lockReconnect) return;
        if (this.changeTab) {
            this.clearWs();
            return;
        }
        if (this.reconnectCount > 20) {
            if (this.reconnectCount === 21) {
                this.reconnectCallback && this.reconnectCallback();
                this.clearWs();
            }
            return;
        }
        const timer = setTimeout(() => {
            //没连接上会一直重连，设置延迟避免请求过多
            this.clearWs()
            clearTimeout(timer)
            this.init(url)
        }, 2000)
    }

    decrypt(data) {
        const aesKey = Buffer.from('...', 'utf8')
        const ivKey = Buffer.from('...', 'utf8')
        let decipher = crypto.createDecipheriv('aes-128-cfb', aesKey, ivKey)
        let sign = decipher.update(e, 'hex', 'utf8')
        sign += decipher.final('utf8')
        return sign
    }
}
